// Єдина логіка сортування значень осі розміру для всієї адмінки:
// спочатку числові розміри (за зростанням), потім буквені (XS→S→M→L→XL…),
// решта нечислових значень (кольори, матеріали) зберігають вихідний порядок.

export const SIZE_LABEL_ORDER = [
    'xxxs',
    'xxs',
    'xs',
    's',
    'm',
    'l',
    'xl',
    'xxl',
    'xxxl',
    '4xl',
    '5xl',
    '6xl',
];

// Повертає число для суто числових значень (36, 9.5, 43), інакше null.
export const parseNumericSize = (value) => {
    const str = String(value ?? '').trim().replace(',', '.');
    if (!/^-?\d+(?:\.\d+)?$/.test(str)) return null;
    const num = Number(str);
    return Number.isFinite(num) ? num : null;
};

// Ранг для буквених розмірів (S, M, L, XL…), включно з комбінованими (S/M, L/XL).
// Комбінований отримує позицію між своїми складовими, щоб «S/M» стояв між S і M.
// Повертає число для відомих розмірів, інакше null.
export const letterSizeRank = (value) => {
    const raw = String(value ?? '').trim().toLowerCase();
    if (!raw) return null;
    const parts = raw
        .split(/[\/\-–]/)
        .map((part) => part.replace(/[^a-z0-9]/g, ''))
        .filter(Boolean);
    if (!parts.length) return null;
    const first = SIZE_LABEL_ORDER.indexOf(parts[0]);
    if (first < 0) return null;
    if (parts.length === 1) return first;
    const second = SIZE_LABEL_ORDER.indexOf(parts[1]);
    return second >= 0 ? (first + second) / 2 : first + 0.5;
};

// Стабільно сортує довільні елементи: getValue дає значення для числового
// розпізнавання, getLabel — людську назву для рангу буквеного розміру.
// Нечислові й невідомі значення лишаються у вихідному порядку одне відносно одного.
export const sortSizeAware = (items = [], { getValue = (item) => item, getLabel } = {}) => {
    const readLabel = getLabel || getValue;
    return items
        .map((item, index) => {
            const num = parseNumericSize(getValue(item)) ?? parseNumericSize(readLabel(item));
            const rank = num === null ? letterSizeRank(readLabel(item)) : null;
            return { item, index, num, rank };
        })
        .sort((a, b) => {
            // 1) числові розміри — завжди першими, за зростанням
            if (a.num !== null && b.num !== null) return a.num !== b.num ? a.num - b.num : a.index - b.index;
            if (a.num !== null) return -1;
            if (b.num !== null) return 1;
            // 2) відомі буквені розміри — у природному порядку
            if (a.rank !== null && b.rank !== null) return a.rank !== b.rank ? a.rank - b.rank : a.index - b.index;
            if (a.rank !== null) return -1;
            if (b.rank !== null) return 1;
            // 3) решта (кольори, матеріали) — зберігають вихідний порядок
            return a.index - b.index;
        })
        .map((entry) => entry.item);
};
